import Rollbar from 'rollbar';
import { OA_VERSION, ROLLBAR_ACCESS_TOKEN } from '../../config.ts';

let rollbar: Rollbar | undefined;

export const initialize = () => {
  rollbar = new Rollbar({
    accessToken: ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      client: {
        javascript: {
          code_version: OA_VERSION,
          guess_uncaught_frames: true,
          source_map_enabled: true,
        },
      },
      environment: 'production',
    },
  });
};

export const getRollbar = (): Rollbar | undefined => rollbar;
